export function mashAddKeyFrame(mesh, scene) {
    // .material.albedoColor = new BABYLON.Color3(...color);
    //https://blog.csdn.net/qq_30100043/article/details/88215661
    if(!mesh.getAnimationByName('flash')){
      let animationBox = flashAnimation(mesh.material.albedoColor.clone())
      mesh.animations = [];
      mesh.animations.push(animationBox);
      mesh.oldAldalbedoColor = mesh.material.albedoColor.clone()
    }
    if(!mesh.isflash){
      scene.beginAnimation(mesh, 0, 60, true);
      mesh.isflash = true
    }
    
    
  }
  export function mashRemoveKeyFrame(mesh,scene) {
      scene.stopAnimation(mesh)
      mesh.isflash = false
      if(mesh.oldAldalbedoColor)mesh.material.albedoColor = mesh.oldAldalbedoColor.clone()
  }
  function flashAnimation(oldColor) {
      var animationBox = new BABYLON.Animation(
          "flash",
          "material.albedoColor",
          30, //当前动画的每秒帧率
          BABYLON.Animation.ANIMATIONTYPE_VECTOR3, //更改的属性值的类型
          // BABYLON.Animation.ANIMATIONTYPE_FLOAT 数字
          // BABYLON.Animation.ANIMATIONTYPE_VECTOR2 二维矢量
          // BABYLON.Animation.ANIMATIONTYPE_VECTOR3 三维矢量
          // BABYLON.Animation.ANIMATIONTYPE_QUATERNION 四元数
          // BABYLON.Animation.ANIMATIONTYPE_MATRIX 矩阵
          // BABYLON.Animation.ANIMATIONTYPE_COLOR3 颜色
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
          //  使用以前的值继续递增运算： BABYLON.Animation.ANIMATIONLOOPMODE_RELATIVE
          // 从初始的值重新动画： BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
          // 保持最后的效果不动：BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
        );
        // 存放动画键的数组
        var keys = [];
        keys.push({
          frame: 0,
          value: new BABYLON.Vector3(oldColor.r, oldColor.g, oldColor.b),
          // outTangent: new BABYLON.Vector3(1, 0, 0),
        });
        keys.push({
          frame: 15,
          // inTangent: new BABYLON.Vector3(1, 0, 0),
          value: new BABYLON.Vector3(1.0, 0.0, 0.0),
          // outTangent: new BABYLON.Vector3(-1, 0, 0),
        });
        keys.push({
          frame: 30,
          value: new BABYLON.Vector3(oldColor.r, oldColor.g, oldColor.b),
          // inTangent: new BABYLON.Vector3(-1, 0, 0),
        });
        animationBox.setKeys(keys);
        return animationBox
  }

  export function meshHide(mesh,scene){
    let duration = 1000
    let animation = new BABYLON.Animation(
      'positionAnimation',
      "visibility",
      60 *1000 / duration  ,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANAMATIONLOOPMODE_CONSTANT
    );
    var keys = [
      {
        frame: 0,
        value: mesh.visibility,
      },
      {
        frame: 60 ,
        value: 0
      }
    ];
    animation.setKeys(keys);
    mesh.animations = [animation];
    mesh.animationCtr = scene.beginAnimation(mesh, 0, 60, false);
    return animation
  }

  export function meshA(mesh,scene,key,from,to){
    let duration = 1000
    let animation = new BABYLON.Animation(
      mesh.id,
      key,
      60 *1000 / duration  ,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANAMATIONLOOPMODE_CONSTANT
    );
    var keys = [
      {
        frame: 0,
        value: from,
      },
      {
        frame: 60 ,
        value: to
      }
    ];
    animation.setKeys(keys);
    mesh.animations = [animation];
    scene.beginAnimation(mesh, 0, 60, false);
    return animation
  }

  
  


// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Animate.js